import Panel from '@common/Panel'
import cls from 'classnames'
import { Button } from 'hljd'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import Store from './store'
import styles from './style.module.less'

const STATUS = {
  '0': '未学习',
  '1': '学习中',
  '2': '已完成'
}

@observer
export default class extends Component {
  constructor() {
    super()
    this.store = new Store()
  }
  componentDidMount() {
    this.store.getData()
  }

  render() {
    const {
      data: { list = [], prompt, subPrompt },
      gotoPage
    } = this.store
    return (
      <>
        {!!list.length &&
          !prompt && (
            <Panel
              title="犀牛学院"
              extra="巧用商家服务特色功能，快速提升客资转化率"
              extraStyle={{ color: '#999', fontSize: 14, marginLeft: 12 }}
              contentStyle={{ padding: 0 }}
              headerStyle={{ justifyContent: 'inherit' }}
            >
              <div className={styles.wrap}>
                <div className={styles.main}>
                  {list.map(item => (
                    <div className={styles.item}>
                      <div className={styles.top}>
                        <img src={item.icon} width={302} />
                        <div className={styles.shadow}>
                          <p className={styles.p1}>{item.title}</p>
                        </div>
                      </div>
                      <div className={styles.bottom}>
                        <p className={styles.p2}>{item.subTitle}</p>
                        <Button
                          type="primary"
                          onClick={gotoPage(item.id, item.title)}
                          className={cls({ [styles.finish]: item.status == 2 })}
                        >
                          {STATUS[item.status]}
                        </Button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </Panel>
          )}
        {!list.length &&
          prompt && (
            <div className={styles.finishBox}>
              <div className={styles.left}>
                <img
                  src="https://qnm.hunliji.com/FnSWRqTFXZOterpfb2vMWhtF-1fR"
                  width={100}
                />
                <div>
                  <p className={styles.p1}>{prompt}</p>
                  <p className={styles.p2}>{subPrompt}</p>
                </div>
              </div>
              <img
                src="https://qnm.hunliji.com/FucNxwTLPFHv8KbBWvKeYW-leqlr"
                width={104}
              />
            </div>
          )}
      </>
    )
  }
}
